interface DialBackHeroProps {
  onGetAccess: () => void;
}

export default function DialBackHero({ onGetAccess }: DialBackHeroProps) {
  return (
    <section
      className="flex flex-col px-12 pt-28 pb-20 relative overflow-hidden max-md:px-6 max-md:pt-24 max-md:pb-14"
      style={{ background: '#0e0d0b' }}
    >
      {/* Radial glow bg */}
      <div
        className="absolute inset-0 pointer-events-none"
        style={{
          background:
            'radial-gradient(ellipse 80% 60% at 70% 30%, rgba(200,71,42,0.08) 0%, transparent 60%), radial-gradient(ellipse 50% 80% at 20% 80%, rgba(200,71,42,0.04) 0%, transparent 50%)',
        }}
      />

      {/* Eyebrow */}
      <div
        className="flex items-center gap-3 mb-6 animate-[fadeUp_0.6s_ease_0.1s_both]"
        style={{ fontFamily: "'DM Mono', monospace", fontSize: '11px', letterSpacing: '0.2em', textTransform: 'uppercase', color: '#c8472a' }}
      >
        <span className="block w-8 h-px bg-[#c8472a]" />
        Jessica — your AI executive assistant
      </div>

      {/* Headline */}
      <h1
        className="font-light leading-[1.0] text-[#f5f2ec] max-w-[900px] mb-4 animate-[fadeUp_0.7s_ease_0.25s_both]"
        style={{
          fontFamily: "'Cormorant Garamond', Georgia, serif",
          fontSize: 'clamp(3.5rem, 8vw, 7.5rem)',
          letterSpacing: '-0.01em',
        }}
      >
        Missed another meeting —<br />
        were you <em className="italic text-[#c8472a]">time traveling</em>
        <br />
        again, Einstein?
      </h1>

      {/* Sub */}
      <p
        className="font-light italic text-[#d4cfc8] max-w-[540px] mb-12 leading-relaxed animate-[fadeUp_0.7s_ease_0.4s_both]"
        style={{
          fontFamily: "'Cormorant Garamond', Georgia, serif",
          fontSize: 'clamp(1.1rem, 2vw, 1.4rem)',
        }}
      >
        Jessica joins your conference bridge, holds your seat, and calls your phone directly — until you answer.
      </p>

      {/* Actions */}
      <div className="flex items-center gap-6 flex-wrap animate-[fadeUp_0.7s_ease_0.55s_both]">
        <button
          onClick={onGetAccess}
          className="text-[13px] font-semibold tracking-[0.1em] uppercase text-[#0e0d0b] bg-[#f5f2ec] px-8 py-4 rounded-sm transition-all duration-200 hover:bg-[#c8472a] hover:text-[#f5f2ec] hover:-translate-y-px whitespace-nowrap cursor-pointer"
          style={{ fontFamily: "'Instrument Sans', sans-serif" }}
        >
          Get early access — $49/month
        </button>
        <p
          className="text-[12px] tracking-[0.06em] text-[#9a9488]"
          style={{ fontFamily: "'DM Mono', monospace" }}
        >
          <strong className="text-[#f5f2ec] font-medium">Unlimited dial-back.</strong> No recording. No transcripts. Just your seat held.
        </p>
      </div>
    </section>
  );
}
